export default "__VITE_ASSET__BdvyEx1W__"